import { render } from "./AssistingAccounting.vue?vue&type=template&id=b93c2286"
import script from "./AssistingAccounting.vue?vue&type=script&lang=js"
export * from "./AssistingAccounting.vue?vue&type=script&lang=js"

import exportComponent from "D:\\develop\\app\\cw\\financial\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__